import { render } from "./Chip.vue?vue&type=template&id=6b7b5cca&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=6b7b5cca&lang=scss&scoped=true"
import "./Chip.vue?vue&type=style&index=1&id=6b7b5cca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7b5cca"]])

export default __exports__